var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
    fill: "#81C240"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2635_1772",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 24,
    width: 31,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6834 24.696C47.6034 23.776 49.095 23.776 50.015 24.696C50.935 25.616 50.935 27.1075 50.015 28.0275L32.7393 45.3032C31.8194 46.2232 30.3278 46.2232 29.4078 45.3032L21.5552 37.4506C20.6352 36.5306 20.6352 35.039 21.5552 34.119C22.4752 33.1991 23.9668 33.1991 24.8868 34.119L31.0736 40.3058L46.6834 24.696Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2635_1772)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5835,
    y: 14.5834,
    width: 40.8333,
    height: 40.8333,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.c5d9b5c1f574d5fd43aea691d5f437f8.svg";
export { ForwardRef as ReactComponent };